import React from 'react'
import './OneColumnA.css';

const OneColumnA = ({ titleA, subtitleA, items }) => {
  return (
    <div >
      <h1 className="headtext__roboto app__content"> {titleA} </h1>
      <div>
        <h3 className="h3__roboto-w"> {subtitleA} </h3>
        <ul className="app__columnA-list">
          {items.map((item, index) => (
            <li className="p__opensans" key={index}>
              <span style={{ fontWeight: 'bold' }}>{item[0].toUpperCase()}</span>
              {item[1]}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default OneColumnA